import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
    selector: "fhm-remove-button",
    templateUrl: "./remove-button.component.html",
    styleUrls: ["./remove-button.component.scss"],
    standalone: false
})
export class RemoveButtonComponent {
    @Output() clicked: EventEmitter<any> = new EventEmitter();

    @Input() title: string;
}
